// This mapping can be used for overriding/disabling components

import ResultsGridItemWithState from "../../../js/datasets/search/ResultsGridItem";

const mapping = {
  "Records_dashboard.Search.ResultsGrid.item": ResultsGridItemWithState,
};

export default mapping;
